<!-- xt销售流水数据操作 salesFlowAction -->
<template>
   <div>
      <div>
         <div class="demo-drawer__content data_action_form">
            <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
               <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="(val) => { mxHeight = val }">
                  <template slot="tabs" slot-scope="scope">
                     <div class="table_content_box">
                        <!-- 主要信息1 -->
                        <div v-if="scope.index == 0">
                           <div id="mainInfo">
                              <el-form @submit.native.prevent class="baseForm" label-width="100px" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                                 <el-row v-if="dataActionBox.actionType != 2">
                                    <el-form-item label="单据类型">
                                       <label slot="label" :style="$common.labelStyle('单据类型')" v-html="'单据类型'"></label>
                                       <el-radio-group v-model="sendDataInfo.docType" @change="docTypeChange">
                                          <el-radio-button label="0">对公</el-radio-button>
                                          <el-radio-button label="1">对私</el-radio-button>
                                          <el-radio-button label="2">三方单位</el-radio-button>
                                       </el-radio-group>
                                    </el-form-item>
                                    <el-form-item :label="formOneValue.showField" :prop="formOneValue.entityField" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform"
                                                  :key="formOneKey" :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                       <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                       <!-- 申请日期 -->
                                       <el-date-picker v-if="formOneValue.fieldType == 'date'" size="mini" v-model="sendDataInfo[formOneValue.entityField]" format="yyyy 年 MM 月 dd 日" value-format="timestamp" type="date"
                                                       placeholder="选择日期" :clearable="false" :editable="false" :isdisabled="formOneValue.isChange == 0"></el-date-picker>

                                       <el-tooltip v-else-if="formOneValue.entityField == 'coName'" class="item"
                                                   :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo[formOneValue.entityField].length<=9"
                                                   effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                          <el-input clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                    @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" :disabled="formOneValue.isChange == 0">
                                             <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"
                                                        :disabled="formOneValue.isChange == 0">
                                             </el-button>
                                          </el-input>
                                       </el-tooltip>
                                       <el-tooltip v-else-if="formOneValue.entityField == 'cmName' && (sendDataInfo.docType == 2||sendDataInfo.docType == 0)" class="item"
                                                   :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo[formOneValue.entityField].length<=9"
                                                   effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                          <el-input v-if="sendDataInfo.docType == 2" clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                    @keyup.enter.native="openSearch(8820873997127684, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                                    :disabled="sendDataInfo.desynOwneracceptdetails.length>0">
                                             <el-button @click="openSearch(8820873997127684, formOneKey, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"
                                                        :disabled="sendDataInfo.desynOwneracceptdetails.length>0">
                                             </el-button>
                                          </el-input>
                                          <el-input v-else clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                    @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                                    :disabled="sendDataInfo.desynOwneracceptdetails.length>0">
                                             <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"
                                                        :disabled="sendDataInfo.desynOwneracceptdetails.length>0">
                                             </el-button>
                                          </el-input>
                                       </el-tooltip>
                                       <el-input v-else-if="formOneValue.entityField == 'cmName' && sendDataInfo.docType ==1" v-model.trim="sendDataInfo[formOneValue.entityField]"
                                                 :disabled="sendDataInfo.desynOwneracceptdetails.length>0" :maxlength="$store.state.inputLength"></el-input>
                                       <el-tooltip v-else-if="formOneValue.fieldType == 'search'" class="item"
                                                   :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo[formOneValue.entityField].length<=9"
                                                   effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                          <el-input clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                    @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" :disabled="formOneValue.isChange == 0">
                                             <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" :disabled="formOneValue.isChange == 0" slot="append"
                                                        icon="el-icon-search">
                                             </el-button>
                                          </el-input>
                                       </el-tooltip>
                                       <el-input v-else v-model.trim="sendDataInfo[formOneValue.entityField]" :disabled="formOneValue.isChange == 0" :maxlength="$store.state.inputLength"></el-input>
                                    </el-form-item>
                                    <el-form-item>
                                       <el-button type="primary" size="mini" @click="openSearch('512271217037312', formOneKey, 'bank', 'rwId,bank,bankAccount,summary,psmoney')">提取流水</el-button>
                                    </el-form-item>
                                 </el-row>
                                 <el-row v-if="dataActionBox.actionType == 2">
                                    <el-form-item :label="formOneValue.showField + ':'" :prop="formOneValue.entityField" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform"
                                                  :key="formOneKey">
                                       <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                       <span v-if="formOneValue.fieldType == 'date'">
                                          <span v-if="sendDataInfo[formOneValue.entityField]">{{
                              $common.getLocalTime(scope.row[formOneValue.entityField])}}</span>
                                       </span>
                                       <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                    </el-form-item>
                                 </el-row>
                              </el-form>
                              <el-divider></el-divider>
                              <!-- 主要信息2 -->
                              <el-form @submit.native.prevent class="baseForm" label-width="100px" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                                 <el-row v-if="dataActionBox.actionType != 2">
                                    <el-form-item label="收款类型" v-show="sendDataInfo.docType == 0">
                                       <el-radio-group v-model="sendDataInfo.payType" @change="payTypeChange">
                                          <el-radio-button label="1">预收</el-radio-button>
                                          <el-radio-button label="2">应收</el-radio-button>
                                          <el-radio-button label="3">退款</el-radio-button>
                                       </el-radio-group>
                                    </el-form-item>
                                    <el-form-item v-for="(secondItem, si) in mainFormList2" :key="si" :label="secondItem.showField" :prop="secondItem.entityField"
                                                  :rules="secondItem.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []" v-if="secondItem.isShow == 1">
                                       <label slot="label" :style="$common.labelStyle(secondItem.showField)" v-html="secondItem.showField"></label>
                                       <template>
                                          <!-- 申请日期 -->
                                          <el-date-picker v-if="secondItem.fieldType == 'date'" size="mini" v-model="sendDataInfo[secondItem.entityField]" format="yyyy 年 MM 月 dd 日" value-format="timestamp" type="date"
                                                          placeholder="选择日期" :clearable="false" :editable="false" :isdisabled="secondItem.isChange == 0"></el-date-picker>
                                          <el-input v-else-if="secondItem.fieldType == 'search'" clearable v-model="sendDataInfo[secondItem.entityField]" :ref="secondItem.entityField" :id="secondItem.entityField"
                                                    @keyup.enter.native="openSearch(secondItem.searchId, si, secondItem.entityField, secondItem.setField)" :disabled="secondItem.isChange == 0">
                                             <el-button @click="openSearch(secondItem.searchId, si, secondItem.entityField, secondItem.setField)" slot="append" icon="el-icon-search" :disabled="secondItem.isChange == 0">
                                             </el-button>
                                          </el-input>
                                          <!-- 业务部门 -->
                                          <el-input v-else-if="secondItem.entityField == 'depId'" disabled v-model="sendDataInfo.depName" :maxlength="$store.state.inputLength"
                                                    :readonly="secondItem.isChange == 0"></el-input>
                                          <!-- 预收金额 -->
                                          <el-input v-else-if="secondItem.entityField == 'preMoney'" :disabled="secondItem.isChange == 0" v-model="sendDataInfo[secondItem.entityField]" type="number" min="0"
                                                    @input="preMoneyChange">
                                          </el-input>
                                          <el-input v-else v-model.trim="sendDataInfo[secondItem.entityField]" :disabled="secondItem.isChange == 0" :maxlength="$store.state.inputLength"></el-input>
                                       </template>
                                    </el-form-item>
                                 </el-row>
                                 <el-row v-if="dataActionBox.actionType == 2">
                                    <el-form-item :label="secondItem.showField + ':'" :prop="secondItem.entityField" v-if="secondItem.isShow == 1" v-for="(secondItem, si) in mainFormList2" :key="si">
                                       <!-- <span v-if="secondItem.isRift == 1">
                                                <a @click="toDetail(sendDataInfo[secondItem.riftField])">{{sendDataInfo[secondItem.entityField]}}</a>
                                            </span> -->
                                       <span v-if="secondItem.entityField == 'opmId'">{{ sendDataInfo.opmName }}</span>
                                       <span v-else-if="secondItem.entityField == 'coId'">{{ sendDataInfo.coName }}</span>
                                       <span v-else-if="secondItem.entityField == 'depId'">{{ sendDataInfo.depName }}</span>
                                       <span v-else-if="secondItem.entityField == 'salesId'">{{ sendDataInfo.salesName }}</span>
                                       <span v-else-if="secondItem.fieldType == 'date'">
                                          <span v-if="sendDataInfo[secondItem.entityField]">{{
                              $common.getLocalTime(sendDataInfo[secondItem.entityField]) }}</span>
                                       </span>
                                       <span v-else>{{ sendDataInfo[secondItem.entityField] }}</span>
                                    </el-form-item>
                                 </el-row>
                              </el-form>
                           </div>
                           <!-- 明细信息 -->
                           <div v-show="sendDataInfo.docType == 0">
                              <el-form @submit.native.prevent :inline="true" size="mini">
                                 <div id="operateBtn" v-if="dataActionBox.actionType != 2" v-show="sendDataInfo.payType == 2">
                                    <el-button type="primary" size="mini" @click="extract('sendDataInfo')">提取</el-button>
                                    <el-button type="primary" size="mini" @click="deleteDetails()">删除
                                    </el-button>
                                 </div>
                                 <el-table size="mini" v-show="sendDataInfo.payType == 2" :data="sendDataInfo.desynOwneracceptdetails" :row-class-name="tableRowClassName" border style="width: 100%" :height="mxHeight">
                                    <el-table-column label="选择操作" width="80" v-if="dataActionBox.actionType != 2">
                                       <template slot-scope="scope">
                                          <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                                             <i class="el-icon-thumb"></i>
                                          </el-radio>
                                       </template>
                                    </el-table-column>
                                    <el-table-column align="center" :prop="formOneValue.entityField" :label="formOneValue.showField" show-overflow-tooltip :min-width="formOneValue.fieldWeight"
                                                     v-for="(formOneValue, formOneKey) in mxForm1" :key="formOneKey" v-if="formOneValue.isShow == 1">
                                       <template slot-scope="scope">
                                          <el-input @input="calculateTotal" v-if="formOneValue.entityField == 'settleMoney' && dataActionBox.actionType != 2" :min="scope.row.oldBalance > 0 ? 0 : scope.row.oldBalance"
                                                    :max="scope.row.oldBalance > 0 ? scope.row.oldBalance : 0" type="number" v-model.trim="sendDataInfo.desynOwneracceptdetails[scope.$index][formOneValue.entityField]"
                                                    :maxlength="$store.state.inputLength"></el-input>
                                          <!-- <span v-else-if="formOneValue.isRift == 1">
														<a
															@click="toDetail(scope.row[formOneValue.riftField])">{{scope.row[formOneValue.entityField]}}</a>
													</span> -->
                                          <span v-else>{{ sendDataInfo.desynOwneracceptdetails[scope.$index][formOneValue.entityField]
                            }}</span>
                                       </template>
                                    </el-table-column>
                                 </el-table>
                              </el-form>
                           </div>
                        </div>
                     </div>
                  </template>
               </v-tabs>
            </el-card>
            <!-- <el-tabs type="border-card" v-model="showTabs" class="el-tabs--border-card_new">
          <el-tab-pane v-for="(scope.row,formKey) in tabForm" :key="formKey" :label="scope.row.jciName" :name="scope.row.jciName">
            
          </el-tab-pane>
        </el-tabs> -->

            <div class="foot">
               <div>
                  <el-button type="primary" @click="initActionBox('sendDataInfo')" v-if="dataActionBox.actionType != 2">取消</el-button>
                  <el-button type="primary" @click="initActionBox('sendDataInfo')" v-if="dataActionBox.actionType == 2">关闭</el-button>
                  <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType == 0">保存</el-button>
                  <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType == 1">保存</el-button>
               </div>
               <el-form @submit.native.prevent :inline="true" :model="sendDataInfo" class="demo-form-inline ml" v-if="footForm">
                  <el-form-item :label="itemV.chineseField" v-for="(itemV, itemK) in footForm" :key="itemK">
                     <el-button type="success">{{ sendDataInfo[itemV.entityField] }}</el-button>
                  </el-form-item>
               </el-form>
            </div>
         </div>
      </div>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
         <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <el-dialog :title="seTitle" v-if="DialogVisible1" :visible.sync="DialogVisible1" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
         <SearchSchemeMultiple ref="searchSchemeMultiple" :id="searchId" :parentData="parentData" :parentSearchData="parentSearchData1" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
         <span slot="footer" class="dialog-footer">
            <el-button @click="DialogVisible1 = false">取 消</el-button>
            <el-button type="primary" @click="getSelect">确认选择</el-button>
         </span>
      </el-dialog>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import SearchScheme from "@/byComponents/SearchScheme.vue";
import SearchSchemeMultiple from "@/byComponents/SearchSchemeMultiple.vue";

export default {
   name: "salesFlowAction",
   props: ["actionData"],
   //import引入的组件需要注入到对象中才能使用
   components: {
      SearchScheme,
      SearchSchemeMultiple,
   },
   data() {
      //这里存放数据
      return {
         selectDataTable: false,
         dataActionBox: {
            showStatus: false,
            openMode: "ltr" || "rtl",
            boxTitle: "新增" || "编辑",
            actionType: 0, // 0新增，1修改
         },
         detaislDataInfo: {},
         selectedDataIndex: 0,
         selectedDataIndex1: 0,
         sendDataInfo: {
            desynOwneracceptdetails: [], //按单据
            cmId: "",
            cmName: "",
            backDate: 0,
            opmId: 0,
            opmName: "",
            salesId: 0,
            salesName: "",
            coId: "",
            coName: "",
            rwId: "",   //	回款流水id
            docType: "",   //单据类型
            payType: "",   //收款类型
            psmoney: "",
            totalCount: 0,
            totalMoney: 0,
            totalNumber: 0,
         },
         sendDataInfo1: {

         },
         ccmainFormList1: [],
         showTabs: "",
         formDataList: [],
         goodsList: [],
         detailsBox: {
            status: false,
            type: 0,
            title: "新增" || "修改",
         },
         editDateilsIndex: "",
         isBuyer: 0,
         exId: "",
         seId: "",
         dialogTitle: "",
         seWidth: "",
         seTitle: "",
         exWidth: "",
         DialogVisible: false,
         DialogVisible1: false,
         DialogExtract: false,
         newFormDataList: [],
         seType: "",
         smId: "",
         parentSearchData: {
            backDate: "",
            cmName: "",
            money: "",
         },
         parentSearchData1: {
            cmId: "",
            coId: "",
            opmId: "",
         },
         parentData: {
            type: "dasmId",
            list: []
         },
         searchId: "",
         mxHeight: 0,
         tabForm: [], // tab循环的主表单
         mxForm1: [],
         mxForm2: [],
         footForm: [],
         mainFormList2: [],
         sField: '',
         midPayType: "",

      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      "sendDataInfo.cmName": {
         handler: function (newValue, oldValue) {
            if (newValue == '') {
               this.sendDataInfo.cmId = ''
               this.initData()
            }
         },
         deep: true,
      },
      "sendDataInfo.cmId": {
         handler: function (newValue, oldValue) {
            this.initData()
         },
         deep: true,
      },
      "sendDataInfo.coName": {
         handler: function (newValue, oldValue) {
            if (newValue == '') {
               this.sendDataInfo.coId = ''
            }
         },
         deep: true,
      },
      "sendDataInfo.desynOwneracceptdetails": {
         handler: function (newValue, oldValue) {
            this.sendDataInfo.totalMoney = 0
            newValue.forEach((v) => {
               if (v.settleMoney) {
                  this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(3, (NP.plus(this.sendDataInfo.totalMoney, v.settleMoney)))
                  // this.sendDataInfo.totalMoney = (NP.plus(this.sendDataInfo.totalMoney, v.settleMoney)).toFixed(2)
               }
            })
         },
         deep: true,
      },
   },
   //方法集合
   methods: {
      //初始数据
      initData() {
         this.sendDataInfo.rwId = ''
         this.sendDataInfo.bank = ''
         this.sendDataInfo.bankAccount = ''
         this.sendDataInfo.summary = ''
         for (const key in this.sendDataInfo1) {
            this.sendDataInfo[key] = ""
         }
      },
      docTypeChange(val) {
         if (val == 1) {
            this.midPayType = this.sendDataInfo.payType;
            this.sendDataInfo.payType = ""
         } else {
            this.sendDataInfo.payType = this.midPayType;
         }
         if (val != 1) {
            this.sendDataInfo.cmId = ""
            this.sendDataInfo.cmName = ""
         }
         this.initData()
         this.payTypeChange()
      },
      payTypeChange() {
         this.mainFormList2.forEach(item => {
            if (this.sendDataInfo.docType == 1 || this.sendDataInfo.docType == 2) {
               if (item.entityField == 'opmName' || item.entityField == 'salesName') {
                  item.isShow = 0
               }
            } else if (this.ccmainFormList1[this.ccmainFormList1.findIndex(items => items.entityField == item.entityField)].isShow) {

               if ((this.sendDataInfo.payType == 1 || this.sendDataInfo.payType == 3 || this.sendDataInfo.payType == "") && (item.entityField == 'opmName' || item.entityField == 'salesName')) {

                  item.isShow = 1
               } else if (this.sendDataInfo.payType == 2 && (item.entityField == 'opmName' || item.entityField == 'salesName')) {
                  item.isShow = 0
               }
            }
         })
         if (this.sendDataInfo.payType == 2) {
            this.sendDataInfo.salesId = ""
            this.sendDataInfo.salesName = ""
            this.sendDataInfo.opmId = ""
            this.sendDataInfo.opmName = ""
         } else {
            this.sendDataInfo.desynOwneracceptdetails = []
         }
         setTimeout(() => {
            if (this.dataActionBox.actionType != 2) {
               this.mxHeight = this.$common.getBtnHeight()
            } else {
               this.mxHeight = this.$common.getHeight()
            }
         }, 16.7)
      },
      // 输入框切换焦点
      nextFocus(index) {
         if (index >= (this.inputel.length - 1)) {
            return
         }
         var aindex = index + 1
         if (this.inputel[aindex].value != '' || this.inputel[aindex].disabled) {
            this.nextFocus(aindex)
            return
         }
         this.inputel[aindex].focus()
      },
      // 获取主表单所有input
      getMainInput() {
         var el = document.getElementById('mainInfo')
         if (el) this.inputel = el.getElementsByTagName('input')
      },
      // 初始化焦点
      initFocus() {
         for (let index = 0; index < this.inputel.length; index++) {
            if (this.inputel[index].value == '') {
               this.inputel[index].focus()
               break
            }
         }
      },
      // 赋值字段
      paramValue(val) {
         let arr = this.sField.split(',')
         arr.forEach(item => {
            this.sendDataInfo[item] = val[item]
         })
         this.$nextTick(() => {
            if (this.sendDataInfo.cmId != '' && this.sendDataInfo.salesId != '' && this.sendDataInfo.coId != '' && this.sendDataInfo.opmId != '') {
               this.getMoney()
            }
            this.nextFocus(this.seIndex)
         })
      },
      async getMoney() {
         let sendData = {
            opmId: this.sendDataInfo.opmId,
            unitId: this.sendDataInfo.cmId,
            salesId: this.sendDataInfo.salesId,
            coId: this.sendDataInfo.coId,
            ormId: JSON.parse(sessionStorage.getItem("loginInfo")).ormId
         }
         var responseData = await this.$http.shipPlanAddLoading(sendData);
         if (responseData.status == 200) {
            let res = responseData.result
            this.sendDataInfo.prereceSum = res.prereceSum
            console.log(this.sendDataInfo.prereceSum)
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      //金额监听
      preMoneyChange(newVal) {
         console.log(Number(newVal) > this.sendDataInfo.prereceSum)
         if (this.sendDataInfo.cmId == "") {
            this.$data.sendDataInfo.preMoney = 0
            return this.$message({
               message: "请先选择客户!",
               type: "warning",
            })
         }
         if (Number(newVal) > Number(this.sendDataInfo.prereceSum)) {
            this.$data.sendDataInfo.preMoney = 0
            return this.$message({
               message: "预收金额不能大于预收余额!",
               type: "warning",
            })
         }
         if (Number(newVal) > this.sendDataInfo.psmoney) {
            this.$data.sendDataInfo.preMoney = 0
            return this.$message({
               message: "预收金额不能大于总金额!",
               type: "warning",
            })
         }
         // this.sendDataInfo.payMoney = NP.minus(this.sendDataInfo.totalMoney, this.sendDataInfo.preMoney)
      },
      showPrintPlan() {
         // 打印方法
         // 调用全局方法 判断Websocket是否连接
         if (this.$printSocketApi.printExeMsg() != false) {
            // 选中的数据
            this.$refs.printPlan.openDia(
               this.actionData.orderId,
               this.actionData.printSouce,
               this.actionData.printJurId
            );
         } else {
            return;
         }
      },
      // 子组件穿透方法
      toDetail(orderId) {
         if (this.dataActionBox.actionType != 2)
            this.$parent.$parent.toDetail(orderId);
         else this.$parent.$parent.$parent.toDetail(orderId);
      },
      calculateTotal() {
         // this.sendDataInfo.totalCount = this.sendDataInfo.desynOwneracceptdetails.length;
         if (this.sendDataInfo.desynOwneracceptdetails.length > 0) {
            this.sendDataInfo.desynOwneracceptdetails.forEach((item) => {
               if (item.oldBalance > 0) {
                  if (item.settleMoney > item.oldBalance)
                     item.settleMoney = item.oldBalance;
                  else if (item.settleMoney < 0) item.settleMoney = 0;
               } else if (item.oldBalance < 0) {
                  if (item.settleMoney < item.oldBalance)
                     item.settleMoney = item.oldBalance;
                  else if (item.settleMoney > 0) item.settleMoney = 0;
               }
               // this.sendDataInfo.psmoney = NP.plus(this.sendDataInfo.psmoney, Number(item.settleMoney));
            });
         }

      },
      getSelect() {
         var mx = JSON.parse(JSON.stringify(this.$refs.searchSchemeMultiple.multipleSelection))
         this.sendDataInfo.desynOwneracceptdetails = mx;
         // this.sendDataInfo.totalCount = this.sendDataInfo.desynOwneracceptdetails.length;
         this.DialogVisible1 = false;
         // this.sendDataInfo.totalMoney = 0;
      },
      extract(sendDataInfo) {
         this.sField = ""		//调用同一返回方法，上次检索字段未清除
         this.$refs[sendDataInfo].validate((valid) => {
            if (valid) {
               if (this.sendDataInfo.rwId == "") {
                  return this.$message.error("请提取流水")
               }
               this.searchId = "779666991583233";
               if (this.sendDataInfo.desynOwneracceptdetails.length > 0) {
                  this.parentData.list = this.sendDataInfo.desynOwneracceptdetails
               }
               this.DialogVisible1 = true;
            } else {
               this.$message({
                  message: '请完善必填项~',
                  type: "warning"
               })
            }
         });
      },
      changeInputModel(val) {
         console.log('检索', this.sField, val);
         if (val != "" || val != undefined) {
            this.DialogVisible = false;
            if (val.depId) {
               this.parentSearchData1.depId = val.depId;
            }
            this.paramValue(val)
            if (this.seType == "cmName") {
               this.parentSearchData1.cmId = val.cmId;
               this.parentSearchData.unitId = val.cmId;
            } else if (this.seType == "salesName") {
               this.parentSearchData1.salesId = val.salesId;
            } else if (this.seType == "opmName") {
               this.parentSearchData1.opmId = val.opmId;
            } else if (this.seType == "coName") {
               this.parentSearchData1.coId = val.coId;
            }
         }
      },
      getSeWidth(e) {
         this.seWidth = e + "%";
      },
      getWidth(e) {
         this.exWidth = e + "%";
      },
      getSearchName(e) {
         this.seTitle = e;
      },
      openSearch(sId, index, type, sField, fField, nosField) {
         // this.parentSearchData = {}
         this.parentSearchData[type] = this.sendDataInfo[type]
         if (type == 'bank') {
            if (this.sendDataInfo.cmName == '' || this.sendDataInfo.money == '' || this.sendDataInfo.backDate == "") {
               return this.$message({
                  message: '请先选择回款日期、付款方和金额信息',
                  type: 'warning'
               });
            }
            if ((this.sendDataInfo['cmName'] == "" || this.sendDataInfo['cmId'] == "") && this.sendDataInfo.docType != 1) {
               return this.$message({
                  message: '请先选择付款方，在提取',
                  type: 'warning'
               });
            }
            this.parentSearchData['cmName'] = this.sendDataInfo['cmName']
            this.parentSearchData['cmId'] = this.sendDataInfo['cmId']
            this.parentSearchData['money'] = this.sendDataInfo['money']
            this.parentSearchData['backDate'] = this.sendDataInfo['backDate']
         } else if (type == 'salesName') {
            this.parentSearchData.unitId = this.sendDataInfo.cmId
            this.parentSearchData.unitName = this.sendDataInfo.cmName
         } else if (type == 'cmName') {
            this.parentSearchData.unitName = this.sendDataInfo.cmName
         } else if (type == 'opmName') {
            this.parentSearchData.payType = this.sendDataInfo.payType
         }
         this.DialogVisible = true;
         this.seId = sId;
         this.seIndex = index;
         this.seType = type;
         this.sField = sField

      },
      tableRowClassName({
         row,
         rowIndex
      }) {
         row.index = rowIndex;
      },
      detailsAction(cate = 0) {
         if (cate == 0) {
            this.editDateilsIndex = "";
            return false;
         }

         var dataInfo = JSON.parse(JSON.stringify(this.detaislDataInfo));
         if (dataInfo.psodPacknum <= 0) {
            this.$message({
               message: "请填写采购数量",
               type: "error",
            });
            return false;
         }
         if (this.editDateilsIndex !== "") {
            this.sendDataInfo.pisOrderDetail.splice(this.editDateilsIndex, 1);
         }
         this.sendDataInfo.pisOrderDetail.push(dataInfo);
         // console.log('this.sendDataInfo.pisOrderDetail',this.sendDataInfo.pisOrderDetail)
         this.editDateilsIndex = "";
         this.detailsBox.status = false;
      },
      initActionBox(sendDataInfo) {
         if (this.dataActionBox.actionType == 2) return this.$emit('drawerCancel');
         this.$confirm("确定取消" + this.dataActionBox.boxTitle + "吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         })
            .then(() => {
               this.$emit("drawerCancel");
               this.init();
               this.$refs.sendDataInfo.resetFields();
            })
            .catch(() => { });
      },
      init() {
         for (let key in this.sendDataInfo) {
            if (key == "desynOwneracceptdetails") {
               for (let sonOne in this.sendDataInfo[key]) {
                  this.sendDataInfo[key][sonOne] = "";
               }
            } else {
               this.sendDataInfo[key] = "";
            }
         }
         // var myDate = new Date();//获取系统当前时间
         // let y = myDate.getFullYear(); //获取完整的年份(4位,1970-????)
         // let m = myDate.getMonth()+1; //获取当前月份(0-11,0代表1月)
         // let d = myDate.getDate(); //获取当前日(1-31)
         // let h = myDate.getHours(); //获取当前小时数(0-23)
         // let n = myDate.getMinutes(); //获取当前分钟数(0-59)
         // let s = myDate.getSeconds(); //获取当前秒数(0-59)
         let de = new Date().toLocaleDateString(); //获取当前日期

         this.sendDataInfo.backDate = new Date(de).getTime();
         this.sendDataInfo.desynOwneracceptdetails = [];
         this.sendDataInfo.docType = "0";
         this.sendDataInfo.payType = "1";
         this.sendDataInfo.totalMoney = 0;
         this.sendDataInfo.totalNumber = 0;
         this.sendDataInfo.totalCount = 0;
      },

      selectDataAction(data) {
         this.detaislDataInfo = {
            // "bgmId":data.bgmId,
            bgmId: data.bgmId,
            bgmName: data.bgmName,
            inRate: data.bgfIntaxrate,
            bgmManufacturer: data.bgmManufacturer,
            bgmSpecifications: data.bgmSpecifications,
            bgmPlaceorigin: data.bgmPlaceorigin,
            money: 0,
            psodPacknum: 0,
            price: 0,
            psodPsdvolume: 0,
            psodPslowerlimit: 0,
            psmoney: 0,
            psodPsnvolume: 0,
            psprice: 0,
            psodPsupperlimit: 0,
            pspmId: "",
            stId: data.stId,
            pspdId: "",
            psodReserves1: "",
            psodReserves2: "",
            psodReserves3: "",
            psodReserves4: "",
            psodReserves5: "",
            psodReserves6: "",
         };
         this.selectDataTable = false;
      },
      openBox() {
         this.dataActionBox.actionType = this.actionData.cate;
         this.formDataList = this.actionData.formData;
         var oldData = this.actionData.oldData;
         this.showTabs = this.actionData.formData[0].jciName;
         this.filterMainField()
         this.init();
         this.payTypeChange()
         if (this.dataActionBox.actionType == 0) {
            this.dataActionBox.boxTitle = "新增信息";
            this.dataActionBox.openMode = "ltr";
            this.parentSearchData.unitId = "";
         } else if (this.dataActionBox.actionType == 1) {
            this.dataActionBox.boxTitle = "编辑信息";
            this.dataActionBox.openMode = "rtl";
            var dataInfo = JSON.parse(JSON.stringify(oldData));
            for (let key in dataInfo) {
               this.sendDataInfo[key] = dataInfo[key];
            }
            this.smId = dataInfo.smId;
         } else {
            this.dataActionBox.boxTitle = "查看信息";
            var dataInfo = JSON.parse(JSON.stringify(oldData));
            for (let key in dataInfo) {
               this.sendDataInfo[key] = dataInfo[key];
            }
         }
         this.$nextTick(() => {
            setTimeout(() => {
               if (this.dataActionBox.actionType != 2) {
                  this.mxHeight = this.$common.getBtnHeight()
               } else {
                  this.mxHeight = this.$common.getHeight()
               }
               this.initFocus();
            }, 16.7)
         });
         console.log(this.sendDataInfo, this.formDataList, this.formDataList[3].jurconfigform[5])
      },
      sendDataAction(sendDataInfo) {
         this.$refs[sendDataInfo].validate((valid) => {
            if (valid) {
               if (this.sendDataInfo.rwId == "") {
                  return this.$message.error("请提取流水")
               }
               this.sub(sendDataInfo);
            } else {
               console.log("error submit!!");
               return false;
            }
         });
      },
      async sub(sendDataInfo) {
         let flag = false
         if (this.sendDataInfo.unitType == 1 && this.sendDataInfo.payType != 3) {
            return this.$message({
               type: "error",
               message: "选择供应商时必须为退款！",
            });
         }
         if (this.sendDataInfo.unitType == 2 && this.sendDataInfo.payType != 1 && this.sendDataInfo.payType != 2) {
            return this.$message({
               type: "error",
               message: "选择客户时必须为应收或者预收！",
            });
         }
         if (this.sendDataInfo.docType == 0 && this.sendDataInfo.payType == 2 && this.sendDataInfo.desynOwneracceptdetails.length < 1) {
            return this.$message({
               type: "error",
               message: "明细不能为空",
            });
         } else if (this.sendDataInfo.payType == 1 || this.sendDataInfo.payType == 3 || this.sendDataInfo.payType == "") {
            this.sendDataInfo.desynOwneracceptdetails = []
         }

         if (flag) return this.$message({
            type: "error",
            message: "单据付款金额不能为0或者空",
         });
         this.sendDataInfo.money = parseFloat(this.sendDataInfo.money)
         this.sendDataInfo.psmoney = parseFloat(this.sendDataInfo.psmoney)
         if (this.sendDataInfo.money < this.sendDataInfo.psmoney) {
            return this.$message({
               type: "error",
               message: "认款金额不能大于总金额",
            });
         }


         if ((this.sendDataInfo.opmName == '' || this.sendDataInfo.opmName == null)
            && this.formDataList[1].jurconfigform[5].isShow == 1 && this.sendDataInfo.payType != 2 && this.sendDataInfo.docType == 0) {
            return this.$message({
               type: "error",
               message: "业务员不能为空！",
            });
         }
         if ((this.sendDataInfo.salesName == '' || this.sendDataInfo.salesName == null)
            && this.formDataList[1].jurconfigform[6].isShow == 1 && this.sendDataInfo.payType != 2 && this.sendDataInfo.docType == 0) {
            return this.$message({
               type: "error",
               message: "对方业务员不能为空！",
            });
         }
         if (this.sendDataInfo.docType == 0 && this.sendDataInfo.payType == 2 && this.sendDataInfo.psmoney != this.sendDataInfo.totalMoney) {
            return this.$message({
               type: "error",
               message: "认款金额需等于单据付款金额之和",
            });
         }
         console.log('62731', this.sendDataInfo);
         var responseData = await this.$http.ownerAcceptAdd(
            this.sendDataInfo
         );
         if (responseData.status == 200) {
            this.init();
            this.$message({
               message: "操作成功",
               type: "success",
            });
            this.$emit("drawerCancel");
            this.$refs.sendDataInfo.resetFields();
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      deleteDetails() {
         if (this.sendDataInfo.desynOwneracceptdetails.length > 0) {
            this.sendDataInfo.desynOwneracceptdetails.splice(
               this.selectedDataIndex,
               1
            );
            this.selectedDataIndex = 0;
            // this.sendDataInfo.totalCount = this.sendDataInfo.desynOwneracceptdetails.length;
         } else {
            return this.$message({
               message: "暂无可删除明细",
               type: "warning",
            });
         }
      },

      // 过滤表单不同类型
      filterMainField() {
         var mainFormList = []
         this.mainFormList2 = []
         this.formDataList.forEach(item => {
            if (item.jciType == 1) {
               mainFormList.push(item)
            } else if (item.jciType == 2) {
               this.ccmainFormList1 = item.jurconfigform
               this.mainFormList2 = [].concat(JSON.parse(JSON.stringify(item.jurconfigform)))
            } else if (item.jciType == 4) {
               this.mxForm1 = [].concat(JSON.parse(JSON.stringify(item.jurconfigform)))
            } else if (item.jciType == 3) {
               this.footForm = JSON.parse(JSON.stringify(item.jurconfigform))
            }
         })
         mainFormList.forEach((key, i) => {
            this.tabForm[i] = JSON.parse(JSON.stringify(key))
            this.tabForm[i].jurconfigform = []
            for (let index = 0; index < key.jurconfigform.length; index++) {
               if (key.jurconfigform[index].isShow == 1) this.tabForm[i].jurconfigform.push(key.jurconfigform[index])
            }
         })
         var arr = [{ entityField: "desynOwneracceptdetails" }]
         var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
         for (let key in obj) {
            this.$set(this.sendDataInfo, key, obj[key])
         }
         this.mainFormList2.forEach(item => {
            if (item.fieldType == 'number') {
               this.$set(this.sendDataInfo, item.entityField, 0)
               this.$set(this.sendDataInfo1, item.entityField, 0)
            } if (item.fieldType == 'search' && item.setField) {
               var arr = item.setField.split(',')
               arr.forEach(item2 => {
                  this.$set(this.sendDataInfo, item2, "")
                  this.$set(this.sendDataInfo1, item2, "")
               })
            } else if (item.fieldType == 'string') {
               this.$set(this.sendDataInfo, item.entityField, "")
               this.$set(this.sendDataInfo1, item.entityField, "")
            } else {
               this.$set(this.sendDataInfo, item.entityField, "")
               this.$set(this.sendDataInfo1, item.entityField, "")
            }
         })
         let de = new Date().toLocaleDateString(); //获取当前日期
         this.$set(this.sendDataInfo, "backDate", new Date(de).getTime())
         this.$set(this.sendDataInfo, "docType", "0")
         this.$set(this.sendDataInfo, "payType", "1")
      }
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.$nextTick(() => {
         this.openBox();
      });
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() { },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() {
      this.getMainInput()
   }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
   height: 200px;
   background-color: red;
}

.table_content_box {
   /* height: 500px !important; */
   overflow-y: auto;
}

.el-row {
   display: flex;
   flex-wrap: wrap;
   padding-right: 20px;
}

.el-drawer {
   outline: none;
}

.flex {
   display: flex;
   align-items: center;
}

.newInput {
   background-color: #fff;
   background-image: none;
   border-radius: 4px;
   border: 1px solid #dcdfe6;
   box-sizing: border-box;
   color: #606266;
   display: inline-block;
   font-size: inherit;
   height: 28px;
   line-height: 28px;
   outline: 0;
   padding: 0 15px;
   transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
   width: 100%;
}

.baseForm .el-row {
   display: flex;
   flex-wrap: wrap;
}

.baseForm ::v-deep .el-form-item--mini.el-form-item,
.baseForm ::v-deep .el-form-item--small.el-form-item {
   margin-bottom: 10px !important;
}

.baseForm ::v-deep .el-textarea__inner {
   width: 193px !important;
}

.baseForm ::v-deep .el-form-item__content {
   width: 193px !important;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
   width: 193px !important;
}
</style>